export default __webpack_public_path__ + "static/media/text.1a117ba3.svg";